// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";

export {
    unsafeHas,
    unsafeGet,
    unsafeSet,
    unsafeDelete
} from "./foreign.js";
//# sourceMappingURL=index.js.map
